/* eslint-disable max-len */
// @noflow
import { PlayerErrors } from './constants';

export const messages = {
  default:
    'There was a problem with your video. Please wait a moment and try again. If the issue persists, contact DISH support at 1 (800) 333-3474',
  drmFailedLicenseRequest:
    'Your programming does not include access to this content. To upgrade your DISH programming, please visit MyDISH or call 800-333-DISH (3474) today!',
  networkError:
    'There was a problem connecting to this video. Please check your internet connection and try again.',
  accessDenied:
    'It looks like you may be using an outdated browser version. Please ensure that you are on the latest browser version, and if you continue experiencing issues, please contact DISH support at 1 (800) 333-3474',
  connectionLost:
    "It looks like you've lost connection to this video. Please ensure you are connected to the internet and if you continue experiencing issues, please contact DISH support at 1 (800) 333-3474",
};

const playerErrors = {
  default: {
    code: 4000,
    message: messages.default,
  },
  [PlayerErrors.DRM_FAILED_LICENSE_REQUEST]: {
    code: 4001,
    message: messages.drmFailedLicenseRequest,
  },
  [PlayerErrors.NETWORK_ERROR]: {
    code: 4003,
    message: messages.networkError,
  },
  [PlayerErrors.ACCESS_DENIED]: {
    code: 4004,
    message: messages.accessDenied,
  },
  [PlayerErrors.CONNECTION_LOST]: {
    code: 4050,
    message: messages.connectionLost,
  },
};

export default playerErrors;
